import * as React from "react"
import * as styles from '../styles/youtube_section.module.css'

export function YouTubeSection() {
  return (
    <div className={styles.container}>
      {/* Steam用 */}
      <div className={styles.steam_widget}>
        <iframe
          className={styles.steam_iframe} // ← Steam用のクラスを付ける
          src="https://store.steampowered.com/widget/3263400/"
          frameBorder="0"
          width="646"
          height="190"
        ></iframe>
      </div>

      {/* YouTube用 */}
      <iframe 
        className={styles.youtube_iframe} // ← YouTube用のクラスを付ける
        src="https://www.youtube.com/embed/5nrvsT8YCAs?si=5CSE971EIiwvH9WK" 
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>
  )
}